// `disabled` is intentionally NOT part of this state model — form components
// expose a separate `disabled?: boolean` prop to keep concerns orthogonal:
// `state` describes the validation outcome (idle / success / error), while
// `disabled` controls interactability and is independent of validation.
export type AppFormState = 'static' | 'success' | 'error'

export const APP_FORM_STATE = {
  Static: 'static',
  Success: 'success',
  Error: 'error',
} as const
